import { Search, Check, ClipboardCopy, Save, X } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

export const AggiungiProdottoDialog = ({
  open, onOpenChange, addSearch, onSearch, addResults, onAdd
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader><DialogTitle>Aggiungi prodotto all'ordine</DialogTitle></DialogHeader>
      <div className="space-y-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Cerca prodotto..." value={addSearch} onChange={e => onSearch(e.target.value)} className="pl-9" data-testid="add-product-search" />
        </div>
        <div className="max-h-64 overflow-y-auto space-y-1">
          {addResults.map(p => (
            <button key={p.id} onClick={() => onAdd(p)} className="w-full text-left p-2.5 rounded-lg hover:bg-muted/50 transition-colors text-sm" data-testid={`add-product-${p.id}`}>
              <span className="font-medium">{p.nome}</span>
              <span className="text-xs text-muted-foreground ml-2">({p.unita_misura || "pz"})</span>
            </button>
          ))}
          {addSearch.length >= 2 && addResults.length === 0 && (
            <p className="text-center text-sm text-muted-foreground py-4">Nessun risultato</p>
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export const MessaggioDialog = ({
  open, onOpenChange, messaggioGenerato, onCopia
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Check className="h-5 w-5 text-emerald-500" />Ordine salvato!
        </DialogTitle>
        <DialogDescription>Copia il messaggio per inviarlo al fornitore.</DialogDescription>
      </DialogHeader>
      <div className="bg-muted/30 border border-border rounded-lg p-4">
        <pre className="text-sm whitespace-pre-wrap text-foreground font-sans leading-relaxed">{messaggioGenerato}</pre>
      </div>
      <DialogFooter className="gap-2">
        <Button onClick={onCopia} className="flex-1 bg-blue-600 hover:bg-blue-700 text-white" data-testid="copia-messaggio-btn">
          <ClipboardCopy className="h-4 w-4 mr-2" />Copia messaggio e chiudi
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const TemplateDialog = ({
  open, onOpenChange, template, setTemplate, onSave
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg">
      <DialogHeader><DialogTitle>Template messaggio ordine</DialogTitle></DialogHeader>
      <div className="space-y-3">
        <Label className="text-xs text-muted-foreground">
          Variabili: {"{operatore}"}, {"{locale}"}, {"{fornitore}"}, {"{lista_prodotti}"}
        </Label>
        <Textarea value={template} onChange={e => setTemplate(e.target.value)} rows={5} className="text-sm" data-testid="template-textarea" />
      </div>
      <DialogFooter>
        <Button onClick={onSave} className="bg-primary" data-testid="save-template-btn">
          <Save className="h-4 w-4 mr-2" />Salva template
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
